import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { APIBASE } from '../../config.js';
import { errorNotification } from '../../utils/errors.js';
import { Modal, PlaceholderLoader } from '..//index.js';
import GridIcon from '../Icons/Grid.js';
import { download } from './utils.js';
const FileWrapper = (props) => {
    const lang = useSelector((s) => s.lang);
    const authToken = useSelector(selectAuthToken);
    const [modalOpen, setModalOpen] = useState(false);
    const { file, icon, modalContent, noWrap } = props;
    const link = file.url
        ? file.url
        : `${APIBASE}/files/${file.fileId}/${encodeURIComponent(file.fileName ?? '')}`;
    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };
    const downloadMutation = useMutation(() => download(authToken || '', link, file.fileName || 'file'), {
        onError: (err) => {
            errorNotification(lang, err, 'any', lang.errorEntities.file);
        },
    });
    const load = () => {
        if (!downloadMutation.isLoading) {
            downloadMutation.mutate();
        }
    };
    const noWrapCSS = {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
    };
    return (React.createElement("div", { style: { maxWidth: '100%' }, onClick: !modalContent || props.download ? load : toggleModal },
        props.preview ? props.preview : null,
        React.createElement("div", { style: noWrap ? noWrapCSS : undefined },
            downloadMutation.isLoading ? (React.createElement(PlaceholderLoaderStyled, { loading: downloadMutation.isLoading })) : null,
            React.createElement("div", { className: "file-icon" },
                icon,
                React.createElement(GridIcon, { className: "file-drag-icon" })),
            file.fileName,
            modalOpen && modalContent && (React.createElement(Modal, { onToggle: toggleModal, header: file.fileName || '-' }, modalContent)))));
};
export default FileWrapper;
const PlaceholderLoaderStyled = (props) => (React.createElement(PlaceholderLoader, { style: {
        borderRadius: '15px',
        position: 'absolute',
        top: '0px',
        left: '0px',
        height: '100%',
        opacity: props.loading ? 0.85 : 0,
        transition: 'opacity .3s',
        cursor: props.loading ? 'progress' : undefined,
    } }));
//# sourceMappingURL=FileWrapper.js.map